import { atom } from 'jotai';

export const SERVER_LAUNCH_OPTIONS = ['browser', 'vscode', 'cursor', 'windsurf', 'none'] as const;
export type ServerLaunchOption = (typeof SERVER_LAUNCH_OPTIONS)[number];

// Type definitions for user preferences
export type UserPreferences = {
  hiddenOrganizationIds?: string[];
  theme?: 'light' | 'dark';
  hasSeenGettingStarted?: boolean;
  hasSeenAgentStudioGettingStarted?: boolean;
  preferredIDE?: ServerLaunchOption;
  // Future preferences can be added here
  // e.g., defaultWorkspaceView?: 'list' | 'grid';
  // e.g., notificationSettings?: {...}
};

// Main atom for storing all user preferences
// Initialized with empty object, will be populated from GraphQL
export const userPreferencesAtom = atom<UserPreferences>({});

// Derived atom for hidden organization IDs specifically
export const hiddenOrganizationIdsAtom = atom(
  (get) => get(userPreferencesAtom).hiddenOrganizationIds || [],
);

// Derived atom for theme preference
export const themePreferenceAtom = atom((get) => get(userPreferencesAtom).theme);

// Derived atom for getting started modal preference
export const hasSeenGettingStartedAtom = atom(
  (get) => get(userPreferencesAtom).hasSeenGettingStarted,
);

// Derived atom for agent studio getting started modal preference
export const hasSeenAgentStudioGettingStartedAtom = atom(
  (get) => get(userPreferencesAtom).hasSeenAgentStudioGettingStarted,
);

// Atom for checking if preferences have been loaded from server
export const preferencesLoadedAtom = atom(false);

// Helper atom to check if a specific organization is hidden
export const isOrganizationHiddenAtom = atom((get) => (organizationId: string) => {
  const hiddenIds = get(hiddenOrganizationIdsAtom);
  return hiddenIds.includes(organizationId);
});

// Derived atom for preferred IDE preference
export const preferredIDEAtom = atom((get) => get(userPreferencesAtom).preferredIDE);
